import { Control, Controller } from 'react-hook-form';
import LabelWithInfo from '../../../components/LabelWithInfo/LabelWithInfo';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
import ChatbotStylingFormValues from '../../../types/ChatbotStylingFormValues';
import { CHATBOT_FONT_FAMILIES } from '../../../constants/chatbotFonts';

interface FontSelectProps {
  readonly id: string;
  readonly label: string;
  readonly name: 'titleFontFamily' | 'bodyFontFamily';
  readonly control: Control<ChatbotStylingFormValues>;
  readonly tooltip: string;
}

const fontOptions = CHATBOT_FONT_FAMILIES.map((family) => ({
  value: family,
  label: <span style={{ fontFamily: `'${family}', sans-serif` }}>{family}</span>
}));

export default function FontSelect({
  id,
  label,
  name,
  control,
  tooltip
}: FontSelectProps): JSX.Element {
  return (
    <div className='space-y-2'>
      <LabelWithInfo htmlFor={id} info={tooltip}>
        {label}
      </LabelWithInfo>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <CustomSelect
            id={id}
            value={field.value}
            onValueChange={field.onChange}
            options={fontOptions}
            fullWidth
          />
        )}
      />
    </div>
  );
}
